import { render, staticRenderFns } from "./CalendarPage.vue?vue&type=template&id=3d834222"
import script from "./CalendarPage.vue?vue&type=script&lang=ts"
export * from "./CalendarPage.vue?vue&type=script&lang=ts"
import style0 from "./CalendarPage.vue?vue&type=style&index=0&id=3d834222&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports